import React, { useState, useEffect, useMemo } from 'react';
import Fuse from 'fuse.js';
import { useDispatch, useSelector } from 'react-redux';
import { closeSearchBar } from '../features/SearchBar';
import { openReader } from '../features/Reader';
import { fetchArgentinianArticles } from '../features/Articles';

const SearchBar = ({ headerHeight }) => {
  const searchBar = useSelector((state) => state.searchBar.value);
  const dispatch = useDispatch();

  const {
    argentinianArticles,
    argentinianArticleLoading,
    argentinianArticleError,
  } = useSelector((state) => state.articles);

  useEffect(() => {
    dispatch(fetchArgentinianArticles());
  }, [dispatch]);

  const [searchQuery, setSearchQuery] = useState('');

  const fuse = useMemo(
    () => new Fuse(argentinianArticles, { keys: ['articleTitle'] }),
    [argentinianArticles]
  );

  // Function to perform fuzzy search on articles
  const fuzzySearchArticles = (query) => {
    if (!query) return argentinianArticles;
    return fuse.search(query).map((result) => result.item);
  };

  // Function to filter articles based on search query
  const filteredArticles = fuzzySearchArticles(searchQuery);

  useEffect(() => {
    const handleScroll = () => {
      if (searchBar.isOpen) {
        dispatch(closeSearchBar());
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [searchBar.isOpen, dispatch]);

  return (
    <>
      {searchBar.isOpen ? (
        <div
          style={{ marginTop: `${headerHeight}px` }}
          className="fixed inset-0 sm:top-10 z-30 sm:m-[15em] p-3 min-h-[70vh] overflow-y-auto bg-[#d6daf0] rounded-md"
        >
          <input
            placeholder="Buscar noticias..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            autoFocus={true}
            className="w-full focus:outline-none p-3 border border-[#34345c] rounded-md"
          />
          {searchQuery ? (
            filteredArticles.length > 0 ? (
              <div className="p-5 flex flex-col gap-3 overflow-y-auto">
                {filteredArticles.map((article) => (
                  <button
                    key={article._id.toString()}
                    onClick={() => {
                      dispatch(openReader(article.articleUrl));
                      dispatch(closeSearchBar());
                      setSearchQuery('');
                    }}
                    className="p-3 border rounded-md border-[#34345c] bg-[#eef2ff]"
                  >
                    <span className="text-[#34345c] text-xl font-bold">
                      {article.articleTitle}
                    </span>
                  </button>
                ))}
              </div>
            ) : (
              <div>No se encontraron artículos.</div>
            )
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default SearchBar;
